<script>
import { VCard } from 'vuetify/lib';
export default VCard.extend({
  props: {
    elevation: {
      default: 0,
      type: [String, Number],
    },
  },
});
</script>
